import { Component, type ErrorInfo, type ReactNode } from 'react';

interface ErrorBoundaryProps {
  children: ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
}

export default class ErrorBoundary extends Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  state: ErrorBoundaryState = { hasError: false };

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('Admin dashboard render failed', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="login-screen">
          <div className="login-card" role="alert">
            <div className="login-logo">
              <div className="sidebar-logo-mark">S</div>
              <div>
                <div className="sidebar-logo-text">Staynow</div>
                <div className="login-subtitle">Console de modération</div>
              </div>
            </div>
            <div className="login-error">
              Cette page n’a pas pu être affichée.
            </div>
            <button
              type="button"
              className="login-button"
              onClick={() => window.location.reload()}
            >
              Réessayer
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
